import Button from "./Button";

export default Button;



// WEBPACK FOOTER //
// ./template/components/Button/index.js